import { API_URL } from '@/config/app';
import { getAppStore } from '@/store/storeInstance';
import { createAccessToken } from '@/utils/agent';
import { getRtkErrorMessage } from '@/utils/apiResponse';
import { isApiResponse } from '@/types/api';

interface UploadContentImageResponse {
  url: string;
  image?: string;
}

export async function uploadContentImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('image', file);

  const { accessToken } = getAppStore().getState().auth;
  const response = await fetch(`${API_URL}/cms/upload-image`, {
    method: 'POST',
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      'x-access-token': createAccessToken(),
    },
    body: formData,
  });

  const json: unknown = await response.json();

  if (!response.ok) {
    throw new Error(getRtkErrorMessage({ data: json }) ?? 'Image upload failed.');
  }

  const payload = isApiResponse<UploadContentImageResponse>(json)
    ? json.data
    : (json as UploadContentImageResponse);

  const url = payload.url ?? payload.image;
  if (!url) {
    throw new Error('Image upload failed.');
  }

  return url;
}
